import {
    Component,
    ChangeDetectionStrategy,
    Input,
    Output,
    EventEmitter,
    SimpleChanges,
    OnChanges,
    OnInit,
    OnDestroy,
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DatalinkDto } from '../../../core/dto/datalink';
import { IsavValidators } from '../../../utils/forms/validators';
import { ChangesService } from '../../../core/changes-warning/changes.service';

@Component({
    selector: 'isav-data-links-form',
    templateUrl: './data-links-form.html',
    styleUrls: ['./data-links-form.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataLinksForm implements OnChanges, OnInit, OnDestroy {
    @Input() value: Partial<DatalinkDto>;
    @Output() save = new EventEmitter<Partial<DatalinkDto>>();
    @Output() remove = new EventEmitter<void>();
    @Output() publish = new EventEmitter<DatalinkDto>();
    @Output() unpublish = new EventEmitter<void>();

    form = new UntypedFormGroup(
        {
            fullNameOfDataSet: new UntypedFormControl(null, [
                IsavValidators.required('Full name of data set is required'),
            ]),
            subtitle: new UntypedFormControl(null),
            description: new UntypedFormControl(null),
            image: new UntypedFormControl(null),
            acronym: new UntypedFormControl(null),
            linkToDataAccessPage: new UntypedFormControl(null, [
                IsavValidators.required('Link to data access page is required!'),
            ]),
            organisation: new UntypedFormControl(
                [],
                [IsavValidators.required('Organisation is required!')]
            ),
            departments: new UntypedFormControl([]),
            format: new UntypedFormControl([], [IsavValidators.required('Format is required!')]),
            keywords: new UntypedFormControl(null),
            startDate: new UntypedFormControl(null, [
                IsavValidators.required('Start date is required!'),
            ]),
            endDate: new UntypedFormControl(null, [
                IsavValidators.required('End date is required!'),
            ]),
            theme: new UntypedFormControl([], [IsavValidators.required('Theme is required!')]),
            topics: new UntypedFormControl([]),
            country: new UntypedFormControl([], [IsavValidators.required('Country is required!')]),
            region: new UntypedFormControl(null, [IsavValidators.required('Region is required!')]),
            location: new UntypedFormControl(null, [IsavValidators.coordinates()]),
            contactName: new UntypedFormControl(null, [
                IsavValidators.required('Contact name is required!'),
            ]),
            contactEmail: new UntypedFormControl(null, [
                IsavValidators.required('Contact email is required!'),
            ]),
            contactSecondaryEmail: new UntypedFormControl(null),
            contactPhone: new UntypedFormControl(null, [
                IsavValidators.required('Contact phone is required!'),
            ]),
            attachments: new UntypedFormControl(null),
        },
        {
            validators: IsavValidators.dates(
                'startDate',
                'endDate',
                'Start date cannot be after the end date!'
            ),
        }
    );

    constructor(private readonly changesService: ChangesService) {}

    ngOnInit() {
        this.changesService.connect(this.form);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.value && this.value) {
            this.form.reset(this.value);
        }
    }

    ngOnDestroy() {
        this.changesService.disconnect(this.form);
    }

    onSave() {
        this.form.reset(this.form.value);
        this.save.emit({
            ...this.form.value,
        });
    }

    onDelete() {
        this.form.reset(this.form.value);
        this.remove.emit();
    }

    onPublish() {
        this.form.reset(this.form.value);
        this.publish.emit({
            ...this.form.value,
        });
    }

    onUnpublish() {
        this.form.reset(this.form.value);
        this.unpublish.emit();
    }
}
